module.exports = __webpack_public_path__ + "img/genswell_1_2.2f4e648e.png";